module.exports = __webpack_public_path__ + "img/file-upload.11f229dc.gif";